(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-share"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-share-action]');
    if (!button) return;

    const wrapper = button.closest('.product-share');
    if (!wrapper) return;

    const url = wrapper.dataset.shareUrl;
    const title = wrapper.dataset.shareTitle;
    const text = wrapper.dataset.shareText;
    const feedback = wrapper.querySelector('.product-share__feedback');
    const action = button.dataset.shareAction;

    const showFeedback = function (message) {
      if (!feedback) return;
      feedback.textContent = message;
      feedback.classList.add('is-visible');
      clearTimeout(feedback._shareTimer);
      feedback._shareTimer = setTimeout(function () {
        feedback.classList.remove('is-visible');
      }, 2200);
    };

    const copyLink = function (message) {
      navigator.clipboard.writeText(url).then(
        function () {
          showFeedback(message);
        },
        function () {
          showFeedback(url);
        }
      );
    };

    if (action === 'native' && navigator.share) {
      navigator.share({ title: title, text: text, url: url }).catch(function () {});
    } else if (action === 'native') {
      copyLink('Link copied — paste it on Instagram');
    } else if (action === 'copy') {
      copyLink('Link copied ✓');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
